import { getFamilyGroups } from "../getFamilyGroups";
export function setMemberProps(node, member, families, familyName) {
    if (node.classList && node.classList.contains("sub-detail")) {
        const propTitleElements = node.querySelectorAll(".sub-title, strong");
        for (let i = 0, l = propTitleElements.length; i < l; i++) {
            const propTitleElement = propTitleElements[i];
            const propValueElement = propTitleElement.parentNode.querySelector(`[class*="sub-text"], em`);
            if (propTitleElement && propValueElement) {
                const propTitle = propTitleElement.innerText
                    .toLowerCase()
                    .trim()
                    // TODO: come back and fix these ignores...
                    // eslint-disable-next-line no-useless-escape
                    .replace(/[\s\.\/,:]+/g, "-")
                    .replace(
                // TODO: come back and fix these ignores...
                // eslint-disable-next-line no-useless-escape
                /-?[\(\[].+|\s+[\)\]]|-?$/g, ""); // TODO: fix this limiting keyof
                const propValue = propValueElement.innerText
                    .trim()
                    .replace(/[ ]+/g, " ");
                if (propTitle == "groups") {
                    const groups = propValue.split(", ");
                    member.groups = groups;
                    families[familyName].groups = getFamilyGroups(member.groups, families[familyName].groups);
                }
                else {
                    member[propTitle] = propValue;
                }
            }
        }
    }
}
